import axiosInstance from "./AxiosInstance";

export function billingHistoryList(data) {
  return axiosInstance.post("recruiter/user/billing-details", data);
}

export function offerPopup(data) {
  return axiosInstance.post("recruiter/user/offer-popup", data);
}
